// extracted by mini-css-extract-plugin
module.exports = {"SearchPanel":"pv_a bhv_cw bhv_jx bhv_jo bhv_a bhv_j bhv_ri bhv_rj","SearchPanel__icon":"pv_b bhv_ui bhv_hb bhv_ro bhv_tu","SearchPanel__input":"pv_c bhv_iv bhv_cx bhv_z"};